import { useGalleryPlacementPeriod } from '@shared/utils/galleryPlacementPeriod/GalleryPlacementPeriodProvider';
import { useCardCategoryContext } from '@apps/card/components/CardCategoryProvider';

/**
 * The seed every placement decision in the gallery derives from (PRNT-5494): promo columns, the
 * repeat shuffle, concierge spacing and the concierge products' order. One value for every caller,
 * so the server and the client — and every hook on the client — agree.
 *
 * Category plus placement period: each category gets its own layout, the same for every visitor
 * (so a server-rendered page stays cacheable), and it rotates once per period. The period comes
 * from the server render, not the client's clock; see `GalleryPlacementPeriodProvider`. The same
 * seed applies whether or not the gallery was server-rendered, so both paths show one layout.
 */
export const useGalleryPlacementSeed = (): string => {
  const { currentCategory } = useCardCategoryContext();
  const placementPeriod = useGalleryPlacementPeriod();
  return `${currentCategory}:${placementPeriod}`;
};
